//@ts-nocheck
import React, { useEffect, useState } from "react";
import "../Modals.css";
import ModalCreationMessage from "../ModalCreationMessage";
import ModalDropdown from "../ModalComponents/ModalDropdown";
import MissionModelingService from "../../MissionModelingService";
import { uuidv4 } from "../../../CommonComponents/CommonFunctions";
import { CircularProgress } from "@mui/material";
import { toast } from "react-toastify";
import { Property } from "cesium";
import { useParams } from "react-router-dom";
import DateTimePicker from "react-datetime-picker";

const SatelliteCreationModal = ({ props, parameterProps }) => {
  const params = useParams()
  const {
    mission_name,
    mission_id
  } = params;

  const [isModalVisible, setisModalVisible] = useState(true);
  const [isSuccessMsgVisible, setIsSuccessMsgVisible] = useState(false);
  const [message, setMessage] = useState("");
  const [selectedTypeDropDownOption, setSelectedTypeDropDownOption] = useState("Walker-Delta");
  const [previousOption, setPreviousOption] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [loading, setLoading] = useState(false)
  const [epoch, setEpoch] = useState("1706769000");
  const [altitude, setAltitude] = useState("500");
  const [eccentricity, setEccentricity] = useState("0");
  const [SMA, setSMA] = useState("0");
  const [inclination, setInclination] = useState("45");
  const [LAN, setLAN] = useState("0");
  const [AOP, setAOP] = useState("0");
  const [TA, setTA] = useState("0");
  const [orbitPerDay, setOrbitPerDay] = useState("2");
  const [noOfSatellite, setNoOfSatellite] = useState("1");

  const orbitalPathTypeOptions = [
    { label: "Default Orbit Path", value: "Default Orbit Path" },
    { label: "SSPO", value: "SSPO" },
    { label: "Repeating SSPO", value: "Repeating SSPO" },
  ];
  const [selectedOrbitalPathTypeDropDownOption, setSelectedOrbitalPathTypeDropDownOption] = useState("Default Orbit Path");
  const [orbitalPathpreviousOption, setOrbitalPathPreviousOption] = useState("");
  const [startTime, setStartTime] = useState(new Date());
  const [startTimeEpoch, setStartTimeEpoch] = useState(() => {
    const date = new Date();
    const utcEpoch = Date.UTC(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate(),
      date.getUTCHours(),
      date.getUTCMinutes(),
      date.getUTCSeconds()
    ) / 1000;

    return utcEpoch;
  });

  const handleOrbitalPathTypeSelectedOption = (selectedOption) => {
    setSelectedOrbitalPathTypeDropDownOption(selectedOption.label);
  };

  const [walkerData, setWalkerData] = useState({
    saperationAngle: "",
    inclinationOfPlane: "",
    satellitePerPlane: "",
  });

  const [polarData, setPolarData] = useState({
    RAAN: "",
  });

  const [sunSynchronusData, setSunSynchronusData] = useState({
    orbitalPeriod: "",
    altitudeOfSatellite: "",
  });

  const [planeItems, showPlaneItems] = useState({
    Reference_Orbit: true,
    Constellation: false,
    TLEs: false,
    Coordinates: false,
  });

  const options = [
    {
      label: "Walker-Delta",
      value: "Walker-Delta",
    },
    {
      label: "Polar",
      value: "Polar",
    },
    {
      label: "Sun-Synchronous",
      value: "Sun-Synchronous",
    },
  ];

  const showSuccessMessage = (msg) => {
    setMessage(msg);
    setIsSuccessMsgVisible(true);
    setTimeout(() => {
      setIsSuccessMsgVisible(false);
      props.setBottombarProps({ bottombarComponent: "", componentId: "", componentData: "" });
      props.setIsSatelliteCreated(!props.isSatelliteCreated)
    }, 2000);
  };

  const addToSidebarComponent = () => {

    props.setSidebarProps({
      isSidebarVisible: props.isSidebarVisible,
      sidebarComponent: props.sidebarComponent,
      isComponentUpdated: true,
    });
  };
  const handleDateChange = (date) => {
    if (date) {
      // Convert selected date to UTC
      const utcDate = new Date(Date.UTC(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        date.getUTCHours(),
        date.getUTCMinutes(),
        date.getUTCSeconds()
      ));

      // Get UTC epoch value
      const utcEpoch = utcDate.getTime();

      // Set the UTC date in the state or perform any other action
      setStartTime(utcDate);
      setStartTimeEpoch(utcEpoch / 1000);

    } else {
      // Handle the case where date is null (remove date)
      setStartTime(null);
      setStartTimeEpoch(null);
    }
  };
  const postPlane = () => {
    setLoading(true)
    setisModalVisible(true);

    let withoutConstellationData = {
      // "name": "",
      "type": planeItems.Constellation ? "Constellation" : "Plane",
      "referenceOrbit": {
        "altitude": parseFloat(altitude),
        "semiMajorAxis": parseFloat(SMA),
        "eccentricity": parseFloat(eccentricity),
        "inclination": parseFloat(inclination),
        "RAAN": parseFloat(LAN),
        "AOP": parseFloat(AOP),
        "TA": parseFloat(TA),
        "epoch": parseFloat(startTimeEpoch)
      }
    }

    let constellationData;

    if (planeItems.Constellation) {
      let property =
        selectedTypeDropDownOption === "Polar" ? "polarProperties" : selectedTypeDropDownOption === "Sun-Synchronous" ? "sunSynchronousProperties" : "walkerDeltaProperties";
      let propertyValue =
        selectedTypeDropDownOption === "Polar" ? {
          "noOfSatellites": parseFloat(noOfSatellite),
          "RAAN": parseFloat(polarData.RAAN)
        } :
          selectedTypeDropDownOption === "Sun-Synchronous" ? {
            "noOfSatellites": parseFloat(noOfSatellite),
            "orbitPeriod": parseFloat(sunSynchronusData.orbitalPeriod),
            "altitudeForEachSatellite": parseFloat(sunSynchronusData.altitudeOfSatellite)
          } : {
            "noOfPlanes": parseFloat(noOfSatellite),
            "noOfSatellitesPerPlane": parseFloat(walkerData.satellitePerPlane),
            // "separationAngleBetweenPlane": parseFloat(walkerData.saperationAngle),
            // "inclinationOfEachPlane":parseFloat( walkerData.inclinationOfPlane)
          }

      constellationData = {
        ...withoutConstellationData,
        constellationType: selectedTypeDropDownOption,
        [property]: propertyValue,
      };
    }

    if (isEdit) {
      if (planeItems.Constellation) {
        console.log("Edit Data ", constellationData);
      } else {
        console.log("Edit Data", withoutConstellationData);
      }
    } else {


      MissionModelingService.getAllPlanes(mission_id)
        .then((result) => {
          if (result?.data) {

            // iam getting latest satellite name from here so do not remove this commented line as it may need in future
            //  console.log("result?.data[result?.data?.length-1]?.name",result?.data[result?.data?.length-1]?.name)

            //  const planeObjects = result?.data.filter(obj => obj.type === "Plane");

            //  // Sort by the epoch of the last satellite in each plane
            //  planeObjects.sort((a, b) => {
            //    const epochA = a.planes[0].satellites[0].orbitParameters.epoch;
            //    const epochB = b.planes[0].satellites[0].orbitParameters.epoch;
            //    return epochB - epochA;
            //  });

            //  // Get the latest Plane object
            //  const latestPlane = planeObjects.length > 0 ? planeObjects[0] : null;

            //  console.log("latestPlane", latestPlane)

            props.setNames({
              ...props.names,
              spaceObjectLatestName: result?.data[result?.data?.length - 1]?.name,
            });

            if (result?.data?.length === 0) {
              // planeItems.Constellation ? constellationData.name = "SpaceObject_01" : withoutConstellationData.name = "SpaceObject_01"
            } else {
              let newEntryNum = parseInt(result?.data[result?.data?.length - 1]?.name?.slice(12, result?.data[result?.data?.length - 1]?.name?.length));
              let spaceObj = newEntryNum < 9 ? "SpaceObject_0" : "SpaceObject_";
              let spaceObjName = spaceObj + (newEntryNum + 1)
              // planeItems.Constellation ? constellationData.name = spaceObjName : withoutConstellationData.name = spaceObjName
            }
            MissionModelingService.postPlane(planeItems.Constellation ? constellationData : withoutConstellationData, mission_id).then((res) => {
              // toast.success("Plane Saved Sccessfully")
              showSuccessMessage("Plane created successfully");
              props.setSidebarProps({ isSidebarVisible: true })
              setLoading(false)
              setisModalVisible(false);
              addToSidebarComponent();
              // props.setBottombarProps({ bottombarComponent: "", componentId: "", componentData: "" }); when iam uncommenting this showsucees message not vissible on ui


            }).catch((err) => {
              console.log('error', err)
              setLoading(false)
            })
          }
        })
        .catch((err) => {
          console.log(err);
          setLoading(false)
        });
    }
  };

  const handleSelectedOption = (selectedOption) => {
    setSelectedTypeDropDownOption(selectedOption.label);
  };

  //This UseEffect used for Edit Option
  useEffect(() => {
    if (props?.["componentId"]) {
      setIsEdit(true);
      setEpoch(props?.componentData?.allData?.planes[0]?.referenceOrbit?.epoch);
      setAltitude(props?.componentData?.allData?.planes[0]?.referenceOrbit?.altitude);
      setEccentricity(props?.componentData?.allData?.planes[0]?.referenceOrbit?.eccentricity);
      setSMA(props?.componentData?.allData?.planes[0]?.referenceOrbit?.semiMajorAxis);
      setInclination(props?.componentData?.allData?.planes[0]?.referenceOrbit?.inclination);
      setLAN(props?.componentData?.allData?.planes[0]?.referenceOrbit?.RAAN);
      setAOP(props?.componentData?.allData?.planes[0]?.referenceOrbit?.AOP);
      setTA(props?.componentData?.allData?.planes[0]?.referenceOrbit?.TA);
      setOrbitPerDay(props?.componentData?.allData?.planes[0]?.referenceOrbit?.orbitPerDay);

      if (props.componentData.type === "Constellation") {
        setSelectedTypeDropDownOption(props?.componentData?.allData?.constellationType);
        showPlaneItems({
          ...planeItems,
          Constellation: true,
        });
      }

      setPreviousOption(props?.componentData?.allData?.constellationType);

      if (props?.componentData?.allData?.constellationType === "Sun-Synchronous") {
        setSunSynchronusData({
          orbitalPeriod: props?.componentData?.allData?.sunSynchronousProperties?.orbitPeriod,
          altitudeOfSatellite: props?.componentData?.allData?.sunSynchronousProperties?.altitudeForEachSatellite,
        });
        setNoOfSatellite(props?.componentData?.allData?.sunSynchronousProperties?.noOfSatellites);
      } else if (props?.componentData?.allData?.constellationType === "Walker-Delta") {
        setWalkerData({
          saperationAngle: props?.componentData?.allData?.walkerDeltaProperties?.separationAngleBetweenPlane,
          inclinationOfPlane: props?.componentData?.allData?.walkerDeltaProperties?.inclinationOfEachPlane,
          satellitePerPlane: props?.componentData?.allData?.walkerDeltaProperties?.noOfSatellitesPerPlane,
        });
        setNoOfSatellite(props?.componentData?.allData?.walkerDeltaProperties?.noOfPlanes);
      } else {
        setPolarData({
          RAAN: props?.componentData?.allData?.polarProperties?.RAAN,
        });
        setNoOfSatellite(props?.componentData?.allData?.polarProperties?.noOfSatellites);
      }
    } else {
      setIsEdit(false);
    }
  }, [props?.componentData]);

  return (
    <>
      {isSuccessMsgVisible && <ModalCreationMessage props={props} message={message} />}
      {isModalVisible && (
        <>
          <div className={props.isSidebarVisible ? "mainModal sidebarOpenModal" : "mainModal"} id="planeModal">
            <div className="modalHeader">
              <div className="modalHeaderImg">
                <svg xmlns="http://www.w3.org/2000/svg" width="21px" height="20px" viewBox="0 0 16 16" fill="none">
                  <path
                    d="M12.3142 8.31075C13.3591 8.31253 14.3731 7.95692 15.1878 7.30301C15.2796 7.23009 15.3548 7.13845 15.4085 7.03419C15.4621 6.92992 15.4928 6.81544 15.4987 6.69836C15.5056 6.5743 15.4859 6.4502 15.441 6.33435C15.3961 6.21849 15.3269 6.11355 15.2382 6.02653L12.9024 3.69192C13.2301 3.3644 13.5745 3.02009 13.9022 2.68417C13.9694 2.62539 14.0283 2.5666 14.0955 2.49942C14.1703 2.41984 14.212 2.31472 14.212 2.20549C14.212 2.09627 14.1703 1.99115 14.0955 1.91157C14.0564 1.87221 14.01 1.84097 13.9588 1.81966C13.9076 1.79834 13.8527 1.78736 13.7972 1.78736C13.7417 1.78736 13.6868 1.79834 13.6356 1.81966C13.5844 1.84097 13.538 1.87221 13.4989 1.91157C13.0956 2.30627 12.7091 2.70097 12.3058 3.09567L9.96999 0.761058C9.88177 0.673947 9.77658 0.605887 9.66095 0.561103C9.54532 0.51632 9.42172 0.495768 9.29781 0.500723C9.18087 0.507508 9.06664 0.538656 8.96246 0.592166C8.85828 0.645676 8.76644 0.720367 8.69285 0.811445C7.99499 1.68272 7.63944 2.77868 7.69298 3.89347L6.47466 5.11956L4.51693 3.16285C4.44026 3.08314 4.34827 3.01973 4.24648 2.97642C4.1447 2.9331 4.03521 2.91078 3.92458 2.91078C3.81395 2.91078 3.70446 2.9331 3.60267 2.97642C3.50088 3.01973 3.40889 3.08314 3.33222 3.16285L0.744331 5.7494C0.587838 5.90674 0.5 6.11959 0.5 6.34145C0.5 6.56331 0.587838 6.77615 0.744331 6.9335L2.70625 8.89021L2.36176 9.22612C1.94616 9.64321 1.71282 10.2079 1.71282 10.7965C1.71282 11.3852 1.94616 11.9498 2.36176 12.3669L3.6305 13.635C3.83612 13.8425 4.08085 14.0072 4.35053 14.1196C4.62022 14.232 4.90952 14.2899 5.20172 14.2899C5.49391 14.2899 5.78321 14.232 6.0529 14.1196C6.32259 14.0072 6.56731 13.8425 6.77293 13.635L7.10902 13.2991L9.06675 15.2558C9.22417 15.4122 9.43713 15.5 9.6591 15.5C9.88108 15.5 10.094 15.4122 10.2515 15.2558L12.8393 12.6609C12.9958 12.5035 13.0837 12.2907 13.0837 12.0688C13.0837 11.8469 12.9958 11.6341 12.8393 11.4768L10.89 9.52844L12.1084 8.30235C12.1767 8.30918 12.2455 8.31198 12.3142 8.31075ZM1.33249 6.34565L3.92878 3.7507L5.8781 5.70741L3.29441 8.29396L1.33249 6.34565ZM12.247 12.073L9.6591 14.6595L7.70138 12.7028L10.2893 10.1163L12.247 12.073ZM7.85262 4.92641C8.06515 5.69616 8.47434 6.39742 9.04001 6.96133C9.60568 7.52523 10.3084 7.93239 11.0791 8.14279L6.17217 13.0472C5.91351 13.3052 5.56298 13.4501 5.19752 13.4501C4.83205 13.4501 4.48152 13.3052 4.22286 13.0472L2.94572 11.7707C2.68753 11.5122 2.54253 11.1618 2.54253 10.7965C2.54253 10.4312 2.68753 10.0809 2.94572 9.82237L7.85262 4.92641ZM9.6339 6.36244C8.97328 5.71079 8.58096 4.83537 8.5343 3.90885C8.48764 2.98234 8.79003 2.07197 9.38183 1.35731L12.0117 3.98584L14.65 6.62278L14.6668 6.64797C13.9396 7.22734 13.0243 7.51851 12.0958 7.46584C11.1673 7.41316 10.2908 7.02033 9.6339 6.36244Z"
                    fill="#F0F0F0"
                  />
                </svg>
              </div>
              <span>Satellites</span>

              <button
                className="modalCloseBtn"
                onClick={() => {
                  setisModalVisible(false);
                  props.setBottombarProps({ bottombarComponent: "", componentId: "", componentData: "" });
                }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M1.19995 10.8L10.8 1.19995" stroke="#F0F0F0" strokeWidth="1.2" strokeLinecap="round" />
                  <path d="M1.19993 1.19995L10.7999 10.8" stroke="#F0F0F0" strokeWidth="1.2" strokeLinecap="round" />
                </svg>
              </button>
            </div>

            <div className="modalScrollableSection">
              <div className="modalBoxShadowDiv">
                <>
                  <div className="modalSubHeader modalAnalysisText modalGreenSubHeader" style={{ paddingTop: "12px" }}>
                    Orbital Path Type
                  </div>
                  <div style={{ margin: "12px" }}>
                    <ModalDropdown
                      options={orbitalPathTypeOptions}
                      isMulti={"false"}
                      handleSelectedOption={handleOrbitalPathTypeSelectedOption}
                      previousOption={orbitalPathpreviousOption}
                    />
                  </div>

                </>
                <div className="modalCheckboxDiv">
                  <input
                    type="checkbox"
                    name="checkboxName"
                    id="checkboxId"
                    className="modalCheckbox"
                  // checked={checked}
                  // onChange={handleChange}
                  />
                  <button
                    className="modalDropDownIconBtn"
                    onClick={() =>
                      showPlaneItems({
                        ...planeItems,
                        Reference_Orbit: !planeItems.Reference_Orbit,
                        Constellation: planeItems.Constellation,
                      })
                    }
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path
                        d={planeItems.Reference_Orbit ? "M6.01108 8.97725L11.9879 15.0003L18.011 9.02344" : "M8.9775 17.9887L15.0005 12.0118L9.02368 5.98877"}
                        stroke="#33E18F"
                        strokeWidth="1.25"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>
                  <div className="modalCheckboxText modalGreenSubHeader">Reference Orbit</div>
                </div>
              </div>

              {planeItems.Reference_Orbit && selectedOrbitalPathTypeDropDownOption === "Default Orbit Path" && (
                <div className="referenceOrbitDiv">
                  <div className="modalAnalysisDiv modalAnalysisDivLong">
                    <div className="modalAnalysisText">Epoch</div>
                    <DateTimePicker
                      dayPlaceholder="dd"
                      monthPlaceholder="mm"
                      yearPlaceholder="yy"
                      hourPlaceholder="hh"  // Use 'hh' for 12-hour format or 'HH' for 24-hour format
                      minutePlaceholder="mm"
                      secondPlaceholder="ss"
                      format={"y-MM-dd HH:mm:ss"}  // Use 'HH' for 24-hour format
                      onChange={handleDateChange}
                      value={startTime}
                      disableClock={true}
                      maxDetail={"second"}
                      locale="en-GB"
                    />
                  </div>

                  <div className="modalAnalysisDiv modalAnalysisDivLong">
                    <div className="modalAnalysisText">Altitude</div>
                    <input
                      value={altitude}
                      onChange={(event) => {
                        setAltitude(event.target.value);
                      }}
                      className="modalAnalysisInput"
                      type="number"
                      placeholder="km"
                    />
                  </div>

                  <div className="modalAnalysisDiv modalAnalysisDivLong">
                    <div className="modalAnalysisText">Eccentricity </div>
                    <input
                      value={eccentricity}
                      onChange={(event) => {
                        setEccentricity(event.target.value);
                      }}
                      className="modalAnalysisInput"
                      type="number"
                      placeholder="degree"
                    />
                  </div>

                  <div className="modalAnalysisDiv modalAnalysisDivLong" style={{ display: "none" }}>
                    <div className="modalAnalysisText">Semi Major Axis (km)</div>
                    <input
                      value={SMA}
                      onChange={(event) => {
                        setSMA(event.target.value);
                      }}
                      className="modalAnalysisInput"
                      type="number"
                      placeholder="km"

                    />
                  </div>

                  <div className="modalAnalysisDiv modalAnalysisDivLong">
                    <div className="modalAnalysisText">Inclination </div>
                    <input
                      value={inclination}
                      onChange={(event) => {
                        setInclination(event.target.value);
                      }}
                      className="modalAnalysisInput"
                      type="number"
                      placeholder="degree"
                    />
                  </div>

                  <div className="modalAnalysisDiv modalAnalysisDivLong">
                    <div className="modalAnalysisText">RAAN</div>
                    <input
                      value={LAN}
                      onChange={(event) => {
                        setLAN(event.target.value);
                      }}
                      className="modalAnalysisInput"
                      type="number"
                      placeholder="degree"
                    />
                  </div>

                  <div className="modalAnalysisDiv modalAnalysisDivLong">
                    <div className="modalAnalysisText">Argument of periapsis </div>
                    <input
                      value={AOP}
                      onChange={(event) => {
                        setAOP(event.target.value);
                      }}
                      className="modalAnalysisInput"
                      type="number"
                      placeholder="degree"
                    />
                  </div>

                  <div className="modalAnalysisDiv modalAnalysisDivLong">
                    <div className="modalAnalysisText">True Anomaly </div>
                    <input
                      value={TA}
                      onChange={(event) => {
                        setTA(event.target.value);
                      }}
                      className="modalAnalysisInput"
                      type="number"
                      placeholder="degree"
                    />
                  </div>
                </div>
              )}

              {planeItems.Reference_Orbit && selectedOrbitalPathTypeDropDownOption === "SSPO" && (
                <div className="referenceOrbitDiv">
                  <div className="modalAnalysisDiv modalAnalysisDivLong">
                    <div className="modalAnalysisText">Epoch(Optional)</div>
                    <input
                      autoComplete="off"
                      value={epoch}
                      onChange={(event) => {
                        setEpoch(event.target.value);
                      }}
                      className="modalAnalysisInput"
                      type="number"
                      placeholder="in UTC"
                      style={{ width: "148px" }}
                    />
                  </div>

                  <div className="modalAnalysisDiv modalAnalysisDivLong">
                    <div className="modalAnalysisText">Altitude (km)</div>
                    <input
                      value={altitude}
                      onChange={(event) => {
                        setAltitude(event.target.value);
                      }}
                      className="modalAnalysisInput"
                      type="number"
                      placeholder="km"
                    />
                  </div>

                  <div className="modalAnalysisDiv modalAnalysisDivLong">
                    <div className="modalAnalysisText">RAAN </div>
                    <input
                      value={LAN}
                      onChange={(event) => {
                        setLAN(event.target.value);
                      }}
                      className="modalAnalysisInput"
                      type="number"
                      placeholder="degree"
                    />
                  </div>
                </div>
              )}

              {planeItems.Reference_Orbit && selectedOrbitalPathTypeDropDownOption === "Repeating SSPO" && (
                <div className="referenceOrbitDiv">
                  <div className="modalAnalysisDiv modalAnalysisDivLong">
                    <div className="modalAnalysisText">Epoch(Optional)</div>
                    <input
                      autoComplete="off"
                      value={epoch}
                      onChange={(event) => {
                        setEpoch(event.target.value);
                      }}
                      className="modalAnalysisInput"
                      type="number"
                      placeholder="in UTC"
                      style={{ width: "148px" }}
                    />
                  </div>

                  <div className="modalAnalysisDiv modalAnalysisDivLong">
                    <div className="modalAnalysisText">Altitude (km)</div>
                    <input
                      value={altitude}
                      onChange={(event) => {
                        setAltitude(event.target.value);
                      }}
                      className="modalAnalysisInput"
                      type="number"
                      placeholder="km"
                    />
                  </div>

                  <div className="modalAnalysisDiv modalAnalysisDivLong">
                    <div className="modalAnalysisText">RAAN </div>
                    <input
                      value={LAN}
                      onChange={(event) => {
                        setLAN(event.target.value);
                      }}
                      className="modalAnalysisInput"
                      type="number"
                      placeholder="degree"
                    />
                  </div>

                  <div className="modalAnalysisDiv modalAnalysisDivLong">
                    <div className="modalAnalysisText">Orbit per day</div>
                    <input
                      value={orbitPerDay}
                      onChange={(event) => {
                        setOrbitPerDay(event.target.value);
                      }}
                      className="modalAnalysisInput"
                      type="number"
                      placeholder="#"
                    />
                  </div>
                </div>
              )}

              <div>
                <div className="modalBoxShadowDiv">
                  <div className="modalCheckboxDiv">
                    <button
                      onClick={() => {
                        showPlaneItems({
                          ...planeItems,
                          Reference_Orbit: !planeItems.Reference_Orbit,
                          Constellation: !planeItems.Constellation,
                        });
                      }}
                      className="modalCheckBoxBtn"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" stroke="#36F097" />
                        {planeItems.Constellation && <path d="M4 8L6.5 10.5L13 4" stroke="#36F097" strokeLinecap="round" strokeLinejoin="round" />}
                      </svg>
                    </button>
                    <div className="modalCheckboxText modalGreenSubHeader">Constellation</div>
                  </div>
                </div>

                {planeItems.Constellation && (
                  <>
                    <div className="modalSubHeader modalAnalysisText">Type</div>
                    <div style={{ margin: "12px" }}>
                      <ModalDropdown options={options} isMulti={"false"} handleSelectedOption={handleSelectedOption} previousOption={previousOption} />
                    </div>

                    {/* {selectedTypeDropDownOption === "Walker-Delta" && <div className="modalSubHeader modalAnalysisText">Separation angle between planes (&Delta;&Theta;)</div>}
                    {selectedTypeDropDownOption === "Walker-Delta" && (
                      <input
                        value={walkerData.saperationAngle}
                        onChange={(e) => {
                          setWalkerData({
                            ...walkerData,
                            saperationAngle: e.target.value,
                          });
                        }}
                        className="modalInputFullLen"
                        type="number"
                        placeholder="360&deg; / Number of orbital planes"
                      ></input>
                    )}

                    {selectedTypeDropDownOption === "Walker-Delta" && <div className="modalSubHeader modalAnalysisText">Inclination of each plane (i)</div>}
                    {selectedTypeDropDownOption === "Walker-Delta" && (
                      <input
                        value={walkerData.inclinationOfPlane}
                        className="modalInputFullLen"
                        type="number"
                        onChange={(e) => {
                          setWalkerData({
                            ...walkerData,
                            inclinationOfPlane: e.target.value,
                          });
                        }}
                        placeholder="&Delta;&Theta; / 2"
                      ></input>
                    )} */}
                    <div className="modalAnalysisDiv modalAnalysisDivLong">
                      <div className="modalAnalysisText">Number of Planes</div>
                      <input
                        value={noOfSatellite}
                        className="modalAnalysisInput"
                        type="number"
                        onChange={(e) => {
                          setNoOfSatellite(e.target.value);
                        }}
                        placeholder=""
                      />
                    </div>

                    {selectedTypeDropDownOption === "Walker-Delta" && (
                      <div className="modalAnalysisDiv modalAnalysisDivLong">
                        <div className="modalAnalysisText">Satellites per plane</div>
                        <input
                          value={walkerData.satellitePerPlane}
                          onChange={(e) => {
                            setWalkerData({
                              ...walkerData,
                              satellitePerPlane: e.target.value,
                            });
                          }}
                          className="modalAnalysisInput"
                          type="number"
                          placeholder=""
                        />
                      </div>
                    )}



                    {selectedTypeDropDownOption === "Polar" && <div className="modalSubHeader modalAnalysisText">RAAN</div>}
                    {selectedTypeDropDownOption === "Polar" && (
                      <input
                        value={polarData.RAAN}
                        className="modalInputFullLen"
                        type="number"
                        onChange={(e) => {
                          setPolarData({
                            ...polarData,
                            RAAN: e.target.value,
                          });
                        }}
                        placeholder="360&deg;* (Satellite Index / n)"
                      ></input>
                    )}

                    {selectedTypeDropDownOption === "Sun-Synchronous" && <div className="modalSubHeader modalAnalysisText">Orbital period (T)</div>}
                    {selectedTypeDropDownOption === "Sun-Synchronous" && (
                      <input
                        value={sunSynchronusData.orbitalPeriod}
                        className="modalInputFullLen"
                        type="number"
                        onChange={(e) => {
                          setSunSynchronusData({
                            ...sunSynchronusData,
                            orbitalPeriod: e.target.value,
                          });
                        }}
                        placeholder="24 hours / Number of orbits per day"
                      ></input>
                    )}

                    {selectedTypeDropDownOption === "Sun-Synchronous" && <div className="modalSubHeader modalAnalysisText">Altitude of each satellite</div>}
                    {selectedTypeDropDownOption === "Sun-Synchronous" && (
                      <input
                        value={sunSynchronusData.altitudeOfSatellite}
                        onChange={(e) => {
                          setSunSynchronusData({
                            ...sunSynchronusData,
                            altitudeOfSatellite: e.target.value,
                          });
                        }}
                        className="modalInputFullLen"
                        type="number"
                        placeholder="Calculated based on orbital period & Kepler's third law."
                      ></input>
                    )}
                  </>
                )}
              </div>
            </div>

            <div className="modalFooter">
              <button
                className="modalFooterclose"
                onClick={() => {
                  setisModalVisible(false);
                  props.setBottombarProps({ bottombarComponent: "", componentId: "", componentData: "" });
                }}
              >
                Close
              </button>
              <button
                className="modalFooterapply"
                onClick={() => {
                  postPlane();

                }}
              >
                {!loading ? "Create" : "Creating..."}&nbsp;
                {loading &&
                  <CircularProgress size={10} className=" text-white" />
                }

              </button>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default SatelliteCreationModal;




